import React, { PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import { GoTo } from 'ui/inputs/GoTo'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import { ScrollableArticleGrid } from 'experiences/learn/articles/ArticleGrid'
import { ShowOnDesktop } from 'components/elements/ShowHide'
import { ShowOnMobile } from 'experiences/learn/common/FaqSection/FaqSection.style'
import { PAGE_BREAKPOINTS } from 'parameters'

interface Props {
	articles: ArticleSummary[]
	title: string
	linkTo: string
	backgroundColor?: string
	isSmallCard?: boolean
}

interface ArticleHeaderProps {
	title: string
	moreArticlesPath: string
}
const ArticleSectionHeader: React.FC<React.PropsWithChildren<PropsWithChildren<ArticleHeaderProps>>> = ({
	title,
	moreArticlesPath,
	children
}) => {
	const MoreArticlesLink = moreArticlesPath && (
		<GoTo direction="none" href={moreArticlesPath}>
			More Articles
		</GoTo>
	)
	if (moreArticlesPath) {
	}

	return (
		<ArticlesContainer>
			<ArticlesTop>
				{title && <h2>{title}</h2>}
				<ShowOnDesktop>{MoreArticlesLink}</ShowOnDesktop>
			</ArticlesTop>
			<DropshadowWrapper>{children}</DropshadowWrapper>
			<ShowOnMobile>
				<ArticlesMobileBottom>{MoreArticlesLink}</ArticlesMobileBottom>
			</ShowOnMobile>
		</ArticlesContainer>
	)
}

export const ArticleSection: React.FC<React.PropsWithChildren<Props>> = ({ articles, title, linkTo, isSmallCard }) => {
	if (articles.length === 0) {
		return null
	}

	return (
		<ArticleSectionHeader title={title} moreArticlesPath={linkTo}>
			<ScrollWrapper>
				<ScrollMargin>
					<ScrollableArticleGrid articles={articles} mode={isSmallCard ? 'mini' : 'standard'} />
				</ScrollMargin>
			</ScrollWrapper>
		</ArticleSectionHeader>
	)
}

const ScrollMargin = styled.div`
	display: inline-block;
	margin: 20px;
`

const ScrollWrapper = styled.div`
	overflow-x: scroll;
	overflow-y: visible;
	-webkit-overflow-scrolling: touch;

	&::-webkit-scrollbar {
		display: none;
	}
`

const DropshadowWrapper = styled.div`
	margin: 0 -20px;
`

const ArticlesContainer = styled.div``

const ArticlesTop = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 12px;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		padding-bottom: 0;
	}
`

const ArticlesMobileBottom = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 4px;
`
